import LocalizedStrings from 'react-localization';

export let strings = new LocalizedStrings({
    en: {
        subjectListing: {
            heading: 'Subjects of',
            paragraph: 'Create subjects and train your chatbot with them.',
            addSubjectButton: 'New Subject',
            deleteSubjectButton: 'Delete all selected'
        }
    },
    es: {
        subjectListing: {
            heading: 'Temas de conversación de',
            paragraph: 'Crea temas de conversación y entrena a tu chatbot.',
            addSubjectButton: 'Nuevo tema de conversación',
            deleteSubjectButton: 'Borra los seleccionados'
        }
    }
});


// WEBPACK FOOTER //
// ./src/redux/components/pages/DashboardConversation/DashboardConversationContent.js